import { Input } from './input';
import { IUIElementOptions } from '../../../interfaces/options';

export class RequiredInput<T> extends Input<T> {
	constructor(
		id: string,
		label: string,
		value: T | KnockoutObservable<T>,
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				rules: [{ rule: 'required', params: true }]
			},
			options || {}
		);
		super(id, label, value, options);
	}
}
